/* Mobile card-media swipe gallery (2026-07-27, rewritten for safety).

   WHY THIS CHANGED AGAIN: the previous version attached listeners to each
   .card__media-swipe element individually, then used a MutationObserver on
   document.body (even debounced) to catch newly-added cards and re-run
   that per-element setup. On a large grid like /collections/all — far
   more products than a single mood collection, each with several images
   in its own swipe strip — that still meant scanning and touching
   potentially hundreds of elements, repeatedly, on a page already juggling
   a lot of images. That's exactly the kind of sustained main-thread work
   that crashes Mobile Safari, and confirmed to still happen even with the
   200ms debounce from the last fix.

   THE FIX: event delegation. A SINGLE set of listeners lives on `document`
   itself, once, forever — never re-attached, never re-scanned. Each event
   checks event.target.closest('.card__media-swipe') to find out if it
   happened inside a swipe gallery, and which one. This means brand-new
   cards (from filtering, infinite scroll, quick-add re-renders) work
   automatically the instant they exist in the DOM — there is no
   MutationObserver, no re-initialization step, and no per-element
   bookkeeping at all. The number of products on the page no longer
   matters to this script's own workload.

   Everything else about the actual behavior is unchanged: native touch
   scrolling is left alone (untouched by this script); mouse users get
   manual drag-to-scroll (needed because click-and-drag over
   overflow-x:auto doesn't scroll on its own); a plain tap/click still
   navigates to the product, since this element sits above the card's
   invisible full-card overlay link (see card-product.liquid/component-
   card.css for why). */
(function () {
  var DRAG_THRESHOLD = 6; // px of movement before it counts as a drag, not a tap

  var state = {
    el: null,
    isDown: false,
    didDrag: false,
    startX: 0,
    startScrollLeft: 0,
    pointerId: null,
    pointerType: null,
  };

  function reset() {
    state.el = null;
    state.isDown = false;
    state.didDrag = false;
    state.pointerId = null;
  }

  document.addEventListener('pointerdown', function (event) {
    var el = event.target.closest('.card__media-swipe');
    if (!el) return;

    state.pointerType = event.pointerType;
    // Touch (and pen) already scroll this element natively via CSS
    // (overflow-x: auto) — only mouse needs the manual path below, since
    // click-and-drag over a scrollable element doesn't scroll on its own.
    if (event.pointerType !== 'mouse') return;

    state.el = el;
    state.isDown = true;
    state.didDrag = false;
    state.startX = event.clientX;
    state.startScrollLeft = el.scrollLeft;
    state.pointerId = event.pointerId;
    el.setPointerCapture(event.pointerId);
  });

  document.addEventListener('pointermove', function (event) {
    if (!state.isDown || event.pointerId !== state.pointerId || !state.el) return;
    var delta = event.clientX - state.startX;
    if (Math.abs(delta) > DRAG_THRESHOLD) {
      state.didDrag = true;
    }
    state.el.scrollLeft = state.startScrollLeft - delta;
  });

  function navigate(el) {
    var url = el.dataset.productUrl;
    if (url) {
      window.location.href = url;
    }
  }

  document.addEventListener('pointerup', function (event) {
    if (!state.isDown || event.pointerId !== state.pointerId || !state.el) return;
    var el = state.el;
    var didDrag = state.didDrag;
    reset();
    if (!didDrag) {
      // A plain mouse tap, not a drag: this element sits ABOVE the card's
      // invisible full-card overlay link, so that overlay never receives
      // the tap — navigate manually so tapping the image still opens the
      // product, same as tapping anywhere else on the card.
      navigate(el);
    }
  });

  document.addEventListener('pointercancel', reset);

  // Touch (and any other non-mouse pointer): the browser scrolls this
  // element natively, and — same as any scrollable element — automatically
  // suppresses the synthetic 'click' that would otherwise follow a touch
  // once the touch moved enough to count as a scroll. So a 'click' here
  // reliably means "a tap that didn't scroll" on touch devices, with no
  // manual drag/tap math needed. Mouse taps are already handled above via
  // pointerup, so this skips those to avoid navigating twice.
  document.addEventListener('click', function (event) {
    var el = event.target.closest('.card__media-swipe');
    if (!el) return;
    if (state.pointerType === 'mouse') return;
    navigate(el);
  });
})();
